import React from "react";
import { ChatWindow } from "../chatbot";
import { useChatSession } from "../../hooks/useChatSession";

const ProfEDemo: React.FC = () => {
  const { messages, pending, error, send, reset } = useChatSession();

  return (
    <section className="pe-section pe-section--white pe-demo" id="try-prof-e">
      <div className="pe-container">
        <div className="pe-eyebrow">Try It</div>
        <div className="pe-demo__layout">
          <div className="pe-demo__copy">
            <h2>Have a 30-second conversation with Prof. E.</h2>
            <p>
              This is the same engine students use in entrepreneurship, medical education
              and wellness programs. Tell it about something you learnt today — and see how
              it nudges, not answers.
            </p>
            <div className="pe-demo__hint">
              <svg
                className="pe-demo__hint-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9 a3 3 0 0 1 5.83 1 c0 2 -3 3 -3 3" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
              <p>
                Prof. E will probably ask a question back instead of giving you an answer.
                That is the point.
              </p>
            </div>
          </div>

          <div>
            <div className="pe-demo__chat-shell">
              <div className="pe-demo__chat-header">
                <div className="pe-demo__avatar">
                  <img
                    src="/images/prof-e/pose-3-warm.png"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <div className="pe-demo__chat-name">Professor E</div>
                  <div className="pe-demo__chat-status">● Online · ready to reflect</div>
                </div>
              </div>

              {messages.length > 0 && (
                <div className="pe-demo__toolbar">
                  <button
                    type="button"
                    className="pe-demo__reset"
                    onClick={reset}
                  >
                    <i className="fas fa-rotate-left" aria-hidden></i> New reflection
                  </button>
                </div>
              )}

              <ChatWindow
                messages={messages}
                pending={pending}
                error={error}
                emptyHint="Try: “I just gave my first presentation and my hands wouldn't stop shaking.”"
                onSend={send}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfEDemo;
